import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {FileListV2Props} from './FileListV2Props.interface';

export function FileListV2({fileList, onClickRemoveFile}: FileListV2Props) {
  return (
    <div className="flex flex-col gap-8pxr">
      {fileList.map((file, index) => (
        <div
          key={`${file.name}-${index}`}
          className="h-48pxr px-18pxr flex items-center bg-theme-solid-10"
        >
          <Text className="font-medium2 text-theme-solid-100 truncate w-full">
            {file.name}
          </Text>
          <Icon
            className="ml-15pxr cursor-pointer"
            type={IconType.ListClose}
            onClick={() => onClickRemoveFile(file)}
          />
        </div>
      ))}
    </div>
  );
}
